export const ru = {
  // terms of use
  terms_of_use: {
    title: 'Условия использования',
    subtitle: 'Начав использование, вы соглашаетесь с ',
    link: 'условиями использования.',
    button_text: 'Принять',
  },

  // main page
  main_page: {
    stars: 'СТАРС',
    pending: 'пендинг',
    available: 'доступный',
    replenish: 'Пополнить',
    send: 'Отправить',
    bring_out: 'Вывести',
    history_of_transactions: 'История транзакций',
    total_balance: 'Общий баланс',
  },

  // menu
  menu: {
    language: 'Язык',
    delete_data: 'Удаление данных',
    enter_promo_code: 'Ввести промокод',
    ton_wallet: 'Ton Wallet',
    support: 'Поддержка',
    exit: 'Выход',
    history_of_transaction: 'История транзакций',
  },

  // languages page
  language_page: {
    ukrainian: 'Украинский',
    english: 'Английский',
    russian: 'Русский',
    german: 'Немецкий',
    choose: 'Выбрать',
  },

  // delete page
  delete_page: {
    title: 'Что будет потеряно при удалении аккаунта?',
    warning: '*нажимая кнопку, вы соглашаетесь с последствиями',
    delete: 'Удалить',
    item_1: 'все активные сессии будут завершены.',
    item_2: 'восстановление аккаунта будет невозможно.',
    item_3: 'все транзакции, которые произошли, будут потеряны.',
    item_4: 'средства, оставшиеся на вашем балансе, не подлежат возврату.',
  },

  // promo code page
  promo_code: {
    input_promo_below: 'Введите свой промокод ниже, чтобы получить подарок.',
    promo: 'Промокод',
    input_promo: 'Введите промокод',
    recieve: 'Получить',
  },

  // info container
  info_container: {
    ton_wallet: {
      connected: 'Подключено',
      not_connected: 'Не подключено',
      wallet_is_connected: 'Ваш кошелек успешно подключен.',
      wallet_is_not_connected: 'В настоящее время ваш кошелек не подключен. Воспользуйтесь кнопкой ниже.',
      connect: 'Подключить',
      turn_off_question: 'Хотите отключить?',
    },
    support: {
      need_help_question: 'Нужна помощь?',
      contact_our_bot: 'Обратитесь к нашему боту, и мы быстро решим ваш вопрос.',
      write_bot: 'Написать боту',
    },
    go_out: {
      want_exit_question: 'Хотите выйти?',
      you_can_sign_in_again: 'Вы можете снова войти в любой момент.',
      log_out_of_account: 'Выйти из аккаунта',
    },
  },

  // bottles page
  bottles_page: {
    bottles: 'Банки',
    filter: 'Фильтр',
    create_bank: 'Создать банку',
    types: {
      my: 'Мои',
      participate: 'Участвую',
      lottery: 'Лотерейные',
      charitable: 'Благотворительные',
    },
    conditions: {
      star_on_tickets_exchange: '1 Star = 20 билетов',
      max_stars: 'Максимум в день: 10 Stars = 200 билетов',
      advertising_on_ticket_exchange: '1 просмотр рекламы = 1 билет',
      max_advertising: 'Максимум: 100 реклам в день (10 реклам в час)',
    },
  },

  // main bottle item
  main_bottle_item: {
    collected: 'Собрано',
    to_end: 'До конца',
    participants: 'Участники',
    daily_lottery: 'Ежедневная лотерея',
    viewing_ads: 'Просмотр рекламы',
    modal: {
      tickets: 'Билетов на балансе:',
      how_works: 'Как работает розыгрыш?',
      description:
        'В ежедневной лотерее участвуют только те, кто собрал билеты — через обмен Stars или просмотр рекламы.',
      item_1: '5 участников получат по 10% призового фонда.',
      item_2: '50 случайных участников выиграют по 1% приза.',
      item_3: 'Розыгрыш проходит автоматически каждый день в 00:00.',
      exchange: 'Обмен на билеты',
      advertising: 'Рекламные билеты',
      views: 'Доступно просмотров:',
    },
  },

  // bottle item
  bottle_item: {
    start_is_expected: 'Ожидается старт',
    fixed: 'фиксированная',
    any: 'произвольная',
  },

  type_of_bottle: {
    lottery: {
      name: 'Лотерейная',
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    },
    charitable: {
      name: 'Благотворительная',
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    },
    button: {
      text: 'Продолжить',
    },
  },

  create_bottle: {
    step: 'Шаг {{step}}',
    choose_type_bank: 'Выберите тип банки',
    input_name_bank: 'Введите название банки',
    input_target_bank: 'Введите цель банки',
    input_desired_amount: 'Введите желаемую сумму входа',
    input_availability_period: 'Введите период доступности банки',
    three_months_maximum: '(3 месяца максимум)',
    set_date: 'Установить дату',
    continue: 'Продолжить',
    on: 'На ',
    from: 'с',
    to: 'по',
    confirm_page: {
      title: 'Внимательно проверьте данные!',
      subtitle: 'После сохранения банки его нельзя будет редактировать или удалить.',
    },
    popup: {
      text: 'Введите желаемую сумму входа или пропустите этот шаг, чтобы создать банк с любой суммой входа.',
    },
  },

  attachment_to_bottle: {
    join_to_bottle: 'Присоединиться к банке',
    input_amount: 'Введите желаемую сумму вклада для участия.',
    button: {
      text: 'Сделать вклад',
    },
    conditional: {
      depositing: 'Внесение вклада',
      text: 'Нажимая “Списать старсы” на этом экране, с вашего аккаунта будет списано указанное количество старсов для участия в этом банке.',
      reset_stars: 'Списать старсы',
      cancel: 'Отменить',
    },
  },

  status_page: {
    confirmation: {
      title: 'Банк создан',
      subtitle: 'Ваш банк успешно создан и готов к использованию.',
      link_text: 'На главную',
    },
    error: {
      title: 'Дата превышает допустимый срок',
      subtitle: 'Вы указали дату, которая превышает 3 месяца. Пожалуйста, попробуйте еще раз.',
      link_text: 'Попробовать еще раз',
    },
    show_bottles: 'Просмотреть банки',
  },

  skip: {
    pretermit: 'Пропустить',
  },

  // NoBottles page
  no_bottles_page: {
    reset_filters: 'Сбросить фильтры',
    nothing: {
      title: 'Ничего не найдено',
      subtitle: 'Попробуйте изменить фильтры для лучшего результата.',
    },
    no_own_bottles: {
      title: 'Нет собственных банков',
      subtitle: 'Создайте банк прямо сейчас с помощью кнопки ниже.',
    },
    no_participations: {
      title: 'Отсутствуют участия в банках',
      subtitle: 'Чтобы присоединиться к банке, получите ссылку от его участника.',
    },
  },

  // Filters block
  filters: {
    fixed: 'Фиксированная',
    any: 'Произвольная',
    active: 'Активные',
    planned: 'Запланированные',
    cancel: 'Отменить',
    type_of_deposit: 'Тип суммы вклада',
    number_of_participants: 'Количество участников',
    up_to_number: 'до {{number}}',
    more_than_number: 'больше {{number}}',
    time_of_bank: 'Время банки',
    apply: 'Применить',
  },

  // bottle page
  bottle_page: {
    before_the_start: 'До старта осталось',
    total_pool: 'Общий пул',
    list_of_participants: 'Список участников',
    join: 'Присоединиться',
    increase_the_contribution: 'Увеличить вклад',
    join_for: 'Присоединиться за',
    you_are_already_member: 'Вы уже являетесь участником',
    type: 'Тип',
    deposit_amount: 'Сумма вклада',
    owner: 'Владелец',
    target: 'Цель',
    ANY: 'произвольная',
    FIXED: 'фиксированная',
    CHARITABLE: 'благотворительная',
    LOTTERY: 'лотерейная',
    exchange: {
      stars_for_tickets: 'Обменять старсы на билеты',
    },
  },

  // small button
  button_small: {
    all: 'Все',
  },

  // participants
  participants: {
    nickname_of_user: 'Ник юзера',
    deposit_and_interest: 'Вклад & процент',
    tickets_and_chance: 'Кол-во билетов & шанс',
    show_me: 'Показать меня',
  },

  // confirmation info
  confirmation_info: {
    bank_type: 'Тип банки',
    bank_name: 'Название банки',
    target_of_bank: 'Цель банки',
    stars: '{{number}} старсов',
    bank_will_available: 'Банка будет доступена',
    any: 'Произвольная',
    amount_received_bank: 'Сумма входа в банк',
    from: 'с {{date}}',
    to: 'по {{date}}',
  },

  // referrals page
  referrals: {
    you_received: 'С помощью рефералов вы получили',
    my_referrals: 'Мои рефералы',
    invite_friends: 'Пригласить друзей',
  },

  // replenishment page
  replenishment: {
    title: 'Пополнение Stars',
    subtitle: 'Введите сумму для пополнения собственного баланса Stars.',
  },
  // transactions page
  transactions_page: {
    today: 'Сегодня',
    INVESTMENT: 'Пополнение',
    DEPOSIT: 'Вклад',
    TRANSFER: 'Перевод',
    WITHDRAWAL: 'Вывод',
    WIN: 'Выигрыш',
    LOSE: 'Проигрыш',
  },

  transaction_input: {
    balance: 'Баланс {{balance}}',
    not_commission: 'Без комиссии',
    commission: 'Комиссия {{commission}}',
    remainder: 'Остаток',
    share_receipt: 'Поделиться квитанцией',
    contact_support: 'Обратиться в поддержку',
    user_receive: 'получите ~ {{value}}',
  },

  transaction_details: {
    status: {
      text: 'Статус',
      processing: 'В обработке',
      completed: 'Выполнено',
    },
    receiver: 'Получатель',
    withdrawal_type: {
      telegram: 'Вывод на телеграм аккаунт',
      ton: 'Вывод в USDT(сеть TON)',
    },
  },

  // notification page
  notifications_page: {
    title: 'Уведомления',
    BOTTLE_WIN: 'Победа!',
    BOTTLE_LOOSE: 'Поражение :(',
    name_bank: 'Название банки',
    owner: 'Владелец',
    result: 'Результат:',
  },

  months: {
    january: 'января',
    february: 'февраля',
    march: 'марта',
    april: 'апреля',
    may: 'мая',
    june: 'июня',
    july: 'июля',
    august: 'августа',
    september: 'сентября',
    october: 'октября',
    november: 'ноября',
    december: 'декабря',
  },

  sending_page: {
    title: 'Отправка Stars',
    subtitle: 'Введите username человека, которому хотите отправить Stars.',
  },

  search_user: {
    results: 'Результаты',
    not_found: 'Не найдено...',
    invite_friend: 'Пригласите друга в систему с помощью кнопки выше.',
  },

  sending_stars: {
    title: 'Отправка Stars для {{username}}',
    subtitle: 'Введите количество Stars, которое хотите отправить.',
    button_text: 'Отправить',
  },

  withdrawal_page: {
    output_stars: 'Вывод Stars',
    choose_preferred_method: 'Выберите желаемый способ вывода Stars.',
    available: 'Доступно:',
    in_account: 'Звёзды на аккаунт',
    in_ton: 'В USDT (сеть TON)',
    stars: {
      title: 'Вывод в настоящие Stars на аккаунт',
      subtitle: 'Введите желаемую сумму для вывода Stars на текущий аккаунт.',
      button_text: 'Вывести',
    },
    ton: {
      title: 'Вывод в крипту USDT(сеть TON)',
      subtitle: 'Введите желаемую сумму от 500 Stars для вывода на ваш Ton Wallet.',
      button_text: 'Вывести',
      wallet: {
        address: 'Введите адрес вашего Ton Wallet.',
      },
    },
  },

  not_enough_stars: {
    title: 'Недостаточно Stars',
  },
  withdraw: {
    title: 'Введите минимум 500 старсов для вывода.',
  },
  limit_is_full: {
    title: 'Ваш лимит на обмен исчерпан',
  },

  error_page: {
    update: 'Обновить',
    support_service: 'Служба поддержки',
    on_main: 'На главную',
    server: {
      title: 'Сервер не отвечает',
      description: 'Возникли трудности с подключением. Пожалуйста, попробуйте позже.',
    },
    connect: {
      title: 'Интернет отсутствует',
      description: 'Ваше интернет-соединение прервано. Проверьте подключение.',
    },
    technical: {
      title: 'Технические работы',
      description: 'Сервер временно недоступен. Спасибо за терпение!',
    },
    general: {
      failed_send: {
        title: 'Не удалось отправить',
        description: 'Произошла ошибка при отправке Stars. Попробуйте позже.',
      },
      replenishment_failed: {
        title: 'Пополнение не удалось',
        description: 'Произошла ошибка обработки платежа. Попробуйте позже.',
      },
      something_went_wrong: {
        title: 'Что-то пошло не так...',
        description: 'Произошла ошибка. Попробуйте позже или обратитесь в поддержку.',
      },
      bank_not_created: {
        title: 'Банка не создана',
        description: 'Не удалось создать банк. Попробуйте позже или обратитесь в поддержку.',
      },
      output_failed: {
        title: 'Вывод не удался',
        description: 'Не удалось обработать запрос на вывод Stars. Попробуйте позже.',
      },
      join_to_bottle_failed: {
        title: 'Не удалось присоединиться к банке',
        description: 'Не удалось обработать запрос на присоединение к банке. Попробуйте позже.',
      },
    },
  },

  // History participate
  history_participations: {
    label: 'История участия',
    titles: {
      broken: 'Разбитые',
      unbroken: 'Не разбитые',
    },
    bank: {
      titles: {
        WAITING: 'Ждём...',
        WIN: 'Победа!',
        DEFEAT: 'Поражение :(',
        name: 'Название банки',
        owner: 'Владелец',
        periodOfTime: 'Промежуток времени',
      },
    },

    nothing: {
      title: 'Здесь пока пусто!',
      subtitle: 'У вас пока нет ни одной разбитой банки.',
      show_bank: 'Посмотреть банки',
    },

    missing: {
      title: 'История участия отсутствует',
      description: 'Вы ещё не участвовали ни в одной банке. Начните сейчас!',
      show_banks: 'Посмотреть банки',
    },
  },

  // Confetti
  confetti: {
    type_of_confetti: {
      replenish: 'Пополнение успешно!',
      send: 'Отправка успешна!',
      withdrawal: 'Заявка принята!',
    },
    description: {
      replenish: 'Баланс вашего аккаунта Stars был успешно пополнен.',
      send: '{{numberOfStars}} Stars были успешно отправлены пользователю {{username}}.',
      withdrawal: 'Статус операции можно отследить в разделе "Транзакции". Рассмотрение занимает до 24 часов.',
    },
    button: {
      on_main: 'На главную',
      show_banks: 'Просмотреть банки',
    },
  },
}
